

// import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// import {
//   FaUser,
//   FaLock,
//   FaEnvelope,
//   FaPhone,
//   FaMapMarkerAlt,
// } from "react-icons/fa";

// function Login() {
//   const [activeTab, setActiveTab] = useState("sitemaster");

//   const [formData, setFormData] = useState({
//     mobile_no: "",
//     password: "",
//   });

//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (!formData.mobile_no || !formData.password) {
//       alert("Mobile number and password are required");
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await axios.post(
//         "https://api.d2associates.in/daso//login",
//         {
//           ...formData,
//           role: activeTab,
//         }
//       );

//       if (res.data.success) {
//         alert(res.data.message);

//         localStorage.setItem("user", JSON.stringify(res.data.user));

//         navigate("/admin/dashboard");
//       }
//     } catch (err) {
//       alert(err.response?.data?.message || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//       }}
//     >
//       {/* 🔥 AUTOFILL FIX */}
//       <style>
//         {`
//           input:-webkit-autofill {
//             -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
//             -webkit-text-fill-color: #fff !important;
//             transition: background-color 9999s ease-in-out 0s;
//           }
//         `}
//       </style>

//       <div
//         style={{
//           background: "rgba(255,255,255,0.08)",
//           padding: "40px 20px",
//           borderRadius: "25px",
//           width: "100%",
//           maxWidth: "420px",
//           textAlign: "center",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: "10px",
//             marginBottom: "20px",
//           }}
//         >
//           <button
//             onClick={() => setActiveTab("sitemaster")}
//             style={{
//               flex: 1,
//               padding: "10px",
//               borderRadius: "25px",
//               background: activeTab === "sitemaster" ? "#0bbd9d" : "#ccc",
//               color: activeTab === "sitemaster" ? "#fff" : "#000",
//               border: "none",
//             }}
//           >
//             Sitemaster
//           </button>

//           <div
//             style={{
//               width: "60px",
//               height: "60px",
//               background: "linear-gradient(135deg, #0bbd9d, #4dd0b0)",
//               borderRadius: "50%",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               color: "#fff",
//               fontSize: "24px",
//               flexShrink: 0,
//             }}
//           >
//             <FaUser />
//           </div>

//           <button
//             onClick={() => setActiveTab("reviewer")}
//             style={{
//               flex: 1,
//               padding: "10px",
//               borderRadius: "25px",
//               background: activeTab === "reviewer" ? "#0bbd9d" : "#ccc",
//               color: activeTab === "reviewer" ? "#fff" : "#000",
//               border: "none",
//             }}
//           >
//             Reviewer
//           </button>
//         </div>

//         {/* NAME */}
//         <div style={inputBox}>
//           <FaUser style={iconStyle} />
//           <input type="text" placeholder="Full Name" style={inputStyle} />
//         </div>

//         {/* MOBILE */}
//         <div style={inputBox}>
//           <FaPhone style={iconStyle} />
//           <input
//             type="text"
//             placeholder="Mobile Number"
//             style={inputStyle}
//             onChange={(e) =>
//               setFormData({ ...formData, mobile_no: e.target.value })
//             }
//           />
//         </div>

      
//         <div style={inputBox}>
//           <FaEnvelope style={iconStyle} />
//           <input type="email" placeholder="Email Address" style={inputStyle} />
//         </div>

        
//         <div style={inputBox}>
//           <FaMapMarkerAlt style={iconStyle} />
//           <input type="text" placeholder="Address" style={inputStyle} />
//         </div>

//         {/* PASSWORD */}
//         <div style={inputBox}>
//           <FaLock style={iconStyle} />
//           <input
//             type="password"
//             placeholder="Password"
//             style={inputStyle}
//             onChange={(e) =>
//               setFormData({ ...formData, password: e.target.value })
//             }
//           />
//         </div>

//         <button
//           onClick={handleLogin}
//           disabled={loading}
//           style={{
//             width: "100%",
//             border: "none",
//             borderRadius: "25px",
//             padding: "12px",
//             background: loading
//               ? "gray"
//               : "linear-gradient(to right, #0bbd9d, #4dd0b0)",
//             color: "#fff",
//             fontWeight: "600",
//             cursor: "pointer",
//           }}
//         >
//           {loading ? "Logging in..." : "Log In"}
//         </button>
//       </div>
//     </div>
//   );
// }

// const inputBox = {
//   display: "flex",
//   alignItems: "center",
//   background: "rgba(255,255,255,0.1)",
//   borderRadius: "25px",
//   padding: "12px 15px",
//   marginBottom: "15px",
// };

// const iconStyle = {
//   color: "#0bbd9d",
//   marginRight: "10px",
// };

// const inputStyle = {
//   border: "none",
//   outline: "none",
//   background: "transparent",
//   width: "100%",
//   color: "#fff",
//   fontSize: "14px",
//   WebkitBoxShadow: "0 0 0 1000px transparent inset",
//   WebkitTextFillColor: "#fff",
//   transition: "background-color 9999s ease-in-out 0s",
// };

// export default Login;


// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { FaUser, FaLock, FaPhone } from "react-icons/fa";

// function Login() {
//   const [formData, setFormData] = useState({
//     mobile_no: "",
//     password: "",
//     role: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

// const handleLogin = async () => {
//   if (!formData.mobile_no || !formData.password || !formData.role) {
//     alert("Mobile, Password and Role required");
//     return;
//   }


//   console.log("FORM DATA =>", formData);

//   try {
//     setLoading(true);

//     const url =
//       formData.role === "sitemaster"
//         ? "https://api.d2associates.in/daso//sitemaster/login"
//         : "https://api.d2associates.in/daso//reviewer/login";

//     const res = await axios.post(url, {
//       mobile_no: formData.mobile_no,
//       password: formData.password,
//     });

//     console.log("RESPONSE =>", res.data); 

//     if (res.data.success) {
//       const user = res.data.user;

//       localStorage.setItem("admin", JSON.stringify(user));

//       if (user.role === "sitemaster") {
//         navigate("/admin/dashboard");
//           window.location.reload();
//       } else {
//         navigate("/admin/dashboard");
//           window.location.reload();
//       }
//     }
//   } catch (err) {
//     console.log("ERROR =>", err.response); 
//     alert(err.response?.data?.message || "Login failed");
//   } finally {
//     setLoading(false);
//   }
// };
//   return (
//     <div style={container}>
//       <div style={card}>
//         <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
//           Login
//         </h4>

//         {/* MOBILE */}
//         <div style={inputBox}>
//           <FaPhone style={icon} />
//           <input
//             type="text"
//             placeholder="Mobile Number"
//             style={input}
//             onChange={(e) =>
//               setFormData({ ...formData, mobile_no: e.target.value })
//             }
//           />
//         </div>

//         {/* PASSWORD */}
//         <div style={inputBox}>
//           <FaLock style={icon} />
//           <input
//             type="text"
//             placeholder="Password"
//             style={input}
//             onChange={(e) =>
//               setFormData({ ...formData, password: e.target.value })
//             }
//           />
//         </div>

//         {/* ROLE */}
//         <div style={inputBox}>
//           <FaUser style={icon} />
//           <select
//             style={input}
//             onChange={(e) =>
//               setFormData({ ...formData, role: e.target.value })
//             }
//           >
//             <option value="">Select Role</option>
//             <option value="sitemaster">Sitemaster</option>
//             <option value="reviewer">Reviewer</option>
//           </select>
//         </div>
    

//         {/* BUTTON */}
//         <button
//           onClick={handleLogin}
//           disabled={loading}
//           style={button}
//         >
//           {loading ? "Logging..." : "Login"}
//         </button>
//       </div>
//     </div>
//   );
// }

// const container = {
//   height: "100vh",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   background: "#f5f5f5",
// };

// const card = {
//   background: "#fff",
//   padding: "30px",
//   borderRadius: "10px",
//   width: "350px",
//   boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
// };

// const inputBox = {
//   display: "flex",
//   alignItems: "center",
//   background: "#f1f1f1",
//   padding: "10px",
//   borderRadius: "20px",
//   marginBottom: "15px",
// };

// const icon = {
//   marginRight: "10px",
//   color: "#2bb673",
// };

// const input = {
//   border: "none",
//   outline: "none",
//   background: "transparent",
//   width: "100%",
// };

// const button = {
//   width: "100%",
//   padding: "10px",
//   borderRadius: "20px",
//   border: "none",
//   background: "#2bb673",
//   color: "#fff",
//   fontWeight: "bold",
// };

// export default Login;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { FaUser, FaLock, FaPhone } from "react-icons/fa";

// function Login() {
//   const [formData, setFormData] = useState({
//     mobile_no: "",
//     password: "",
//     role: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

  
//   useEffect(() => {
//     console.log("FORM DATA UPDATE =>", formData);
//   }, [formData]);
  

//   const handleLogin = async () => {
//     if (!formData.mobile_no || !formData.password || !formData.role) {
//       alert("Mobile, Password and Role required");
//       return;
//     }

//     console.log("FORM DATA =>", formData);

//     try {
//       setLoading(true);

//       const url =
//         formData.role === "sitemaster"
//           ? "https://api.d2associates.in/daso//sitemaster/login"
//           : "https://api.d2associates.in/daso//reviewer/login";

//       const res = await axios.post(url, {
//         mobile_no: formData.mobile_no,
//         password: formData.password,
//       });

//       console.log("RESPONSE =>", res.data);

//       if (res.data.success) {
//         const user = res.data.user;

//         localStorage.setItem("admin", JSON.stringify(user));

      
//         if (user.role === "sitemaster") {
//           navigate("/admin/dashboard");
//         } else {
//           navigate("/admin/dashboard");
//         }
//       }
//     } catch (err) {
//       console.log("ERROR =>", err.response);
//       alert(err.response?.data?.message || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={container}>
//       <div style={card}>
//         <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
//           Login
//         </h4>

    
//         <div style={inputBox}>
//           <FaPhone style={icon} />
//           <input
//             type="text"
//             placeholder="Mobile Number"
//             style={input}
//             value={formData.mobile_no}  
//             onChange={(e) =>
//               setFormData({ ...formData, mobile_no: e.target.value })
//             }
//           />
//         </div>


//         <div style={inputBox}>
//           <FaLock style={icon} />
//           <input
//             type="password"   
//             placeholder="Password"
//             style={input}
//             value={formData.password}  
//             onChange={(e) =>
//               setFormData({ ...formData, password: e.target.value })
//             }
//           />
//         </div>


//         <div style={inputBox}>
//           <FaUser style={icon} />
//           <select
//             style={input}
//             value={formData.role}  
//             onChange={(e) =>
//               setFormData({ ...formData, role: e.target.value })
//             }
//           >
//             <option value="">Select Role</option>
//             <option value="sitemaster">Sitemaster</option>
//             <option value="reviewer">Reviewer</option>
//           </select>
//         </div>


//         <button
//           onClick={handleLogin}
//           disabled={loading}
//           style={button}
//         >
//           {loading ? "Logging..." : "Login"}
//         </button>
//       </div>
//     </div>
//   );
// }

// const container = {
//   height: "100vh",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   background: "linear-gradient(135deg, #6c4636, #a67c6b)", 
// };

// const card = {
//   background: "#ffffff",
//   padding: "35px 30px",
//   borderRadius: "16px",
//   width: "350px",
//   boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
//   backdropFilter: "blur(10px)",
// };

// const inputBox = {
//   display: "flex",
//   alignItems: "center",
//   background: "#f7f7f7",
//   padding: "12px",
//   borderRadius: "25px",
//   marginBottom: "15px",
//   border: "1px solid #eee",
// };

// const icon = {
//   marginRight: "10px",
//   color: "#6c4636", 
// };

// const input = {
//   border: "none",
//   outline: "none",
//   background: "transparent",
//   width: "100%",
//   fontSize: "14px",
// };

// const button = {
//   width: "100%",
//   padding: "12px",
//   borderRadius: "25px",
//   border: "none",
//   background: "#D4c2BB", 
//   color: "#3e2a22",
//   fontWeight: "bold",
//   cursor: "pointer",
//   transition: "0.3s",
// };

// export default Login;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import "../../App.css";
// import { FaUser, FaLock, FaPhone } from "react-icons/fa";
// import logo from"../../Images/logo2.png";

// function Login() {
//   const [formData, setFormData] = useState({
//     mobile_no: "",
//     password: "",
//     role: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     console.log("FORM DATA UPDATE =>", formData);
//   }, [formData]);

//   const handleLogin = async () => {
//     if (!formData.mobile_no || !formData.password || !formData.role) {
//       alert("Mobile, Password and Role required");
//       return;
//     }

//     console.log("FORM DATA =>", formData);

//     try {
//       setLoading(true);

//       const url =
//         formData.role === "sitemaster"
//           ? "https://api.d2associates.in/daso//sitemaster/login"
//           : "https://api.d2associates.in/daso//reviewer/login";

//       const res = await axios.post(url, {
//         mobile_no: formData.mobile_no,
//         password: formData.password,
//       });

//       console.log("RESPONSE =>", res.data);

//       if (res.data.success) {
//         const user = res.data.user;
//         localStorage.setItem("admin", JSON.stringify(user));

//         navigate("/admin/dashboard");
//           window.location.reload();
//       }
//     } catch (err) {
//       console.log("ERROR =>", err.response);
//       alert(err.response?.data?.message || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={container}>
//       <div style={card}>
//      <div style={{ textAlign: "center", marginBottom: "20px" }}>
//   <img
//     src={logo}
//     alt="logo"
//     style={{
//       height: "120px",
//       objectFit: "contain",
//     }}
//   />
// </div>

//         {/* MOBILE */}
//         <div
//           style={inputBox}
//           onMouseEnter={(e) =>
//             (e.currentTarget.style.background = "#f1e7e3")
//           }
//           onMouseLeave={(e) =>
//             (e.currentTarget.style.background = "#f7f7f7")
//           }
//         >
//           <FaPhone style={icon} />
//           <input
//             type="text"
//             placeholder="Mobile Number"
//             style={input}
//             value={formData.mobile_no}
//             onChange={(e) =>
//               setFormData({ ...formData, mobile_no: e.target.value })
//             }
//           />
//         </div>

//         {/* PASSWORD */}
//         <div
//           style={inputBox}
//           onMouseEnter={(e) =>
//             (e.currentTarget.style.background = "#f1e7e3")
//           }
//           onMouseLeave={(e) =>
//             (e.currentTarget.style.background = "#f7f7f7")
//           }
//         >
//           <FaLock style={icon} />
//           <input
//             type="password"
//             placeholder="Password"
//             style={input}
//             value={formData.password}
//             onChange={(e) =>
//               setFormData({ ...formData, password: e.target.value })
//             }
//           />
//         </div>

  
//         <div
//           style={inputBox}
//           onMouseEnter={(e) =>
//             (e.currentTarget.style.background = "#f1e7e3")
//           }
//           onMouseLeave={(e) =>
//             (e.currentTarget.style.background = "#f7f7f7")
//           }
//         >
//           <FaUser style={icon} />
//           <select
//             style={selectStyle}
//             value={formData.role}
//             onChange={(e) =>
//               setFormData({ ...formData, role: e.target.value })
//             }
//             onFocus={(e) =>
//               (e.target.parentElement.style.border =
//                 "1px solid #6c4636")
//             }
//             onBlur={(e) =>
//               (e.target.parentElement.style.border =
//                 "1px solid #eee")
//             }
//           >
//             <option value="">Select Role</option>
//             <option value="sitemaster">Sitemaster</option>
//             <option value="reviewer">Reviewer</option>
//           </select>
//         </div>

//         {/* BUTTON */}
//         <button
//           onClick={handleLogin}
//           disabled={loading}
//           style={button}
//           onMouseEnter={(e) =>
//             (e.target.style.background = "#c1a99f")
//           }
//           onMouseLeave={(e) =>
//             (e.target.style.background = "#D4c2BB")
//           }
//         >
//           {loading ? "Logging..." : "Login"}
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ================= STYLES ================= */

// const container = {
//   height: "100vh",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   background: "linear-gradient(135deg, #f5e2db, #a67c6b)",
// };

// const card = {
//   background: "#ffffff",
//   padding: "35px 30px",
//   borderRadius: "16px",
//   width: "350px",
//   boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
// };

// const inputBox = {
//   display: "flex",
//   alignItems: "center",
//   background: "#f7f7f7",
//   padding: "12px 14px",
//   borderRadius: "25px",
//   marginBottom: "15px",
//   border: "1px solid #eee",
//   transition: "0.3s",
// };

// const icon = {
//   marginRight: "10px",
//   color: "#6c4636",
// };

// const input = {
//   border: "none",
//   outline: "none",
//   background: "transparent",
//   width: "100%",
//   fontSize: "14px",
// };

// const selectStyle = {
//   border: "none",
//   outline: "none",
//   background: "transparent",
//   width: "100%",
//   fontSize: "14px",
//   cursor: "pointer",
// };

// const button = {
//   width: "100%",
//   padding: "12px",
//   borderRadius: "25px",
//   border: "none",
//   background: "#D4c2BB",
//   color: "#3e2a22",
//   fontWeight: "bold",
//   cursor: "pointer",
//   transition: "0.3s",
// };

// export default Login;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { FaUser, FaLock, FaPhone } from "react-icons/fa";
import logo from "../../Images/logo2.png";

function Login() {
  const [formData, setFormData] = useState({
    mobile_no: "",
    password: "",
    role: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // console.log("FORM DATA UPDATE =>", formData);
  }, [formData]);

  const handleLogin = async () => {
    if (!formData.mobile_no || !formData.password || !formData.role) {
      alert("Mobile, Password and Role required");
      return;
    }

    try {
      setLoading(true);

      const url =
        formData.role === "sitemaster"
          ? "https://api.d2associates.in/sitemaster/login"
          : "https://api.d2associates.in/reviewer/login";

      const res = await axios.post(url, {
        mobile_no: formData.mobile_no,
        password: formData.password,
      });

      if (res.data.success) {
        localStorage.setItem("admin", JSON.stringify(res.data.user));
        navigate("/admin/dashboard");
        window.location.reload();
      }
    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <div style={card}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img
            src={logo}
            alt="logo"
            style={{
              width: "100%",
              maxWidth: "140px",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </div>

        <div style={inputBox}>
          <FaPhone style={icon} />
          <input
            type="text"
            placeholder="Mobile Number"
            style={input}
            value={formData.mobile_no}
            onChange={(e) =>
              setFormData({ ...formData, mobile_no: e.target.value })
            }
          />
        </div>

        <div style={inputBox}>
          <FaLock style={icon} />
          <input
            type="password"
            placeholder="Password"
            style={input}
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
          />
        </div>

        <div style={inputBox}>
          <FaUser style={icon} />
          <select
            style={selectStyle}
            value={formData.role}
            onChange={(e) =>
              setFormData({ ...formData, role: e.target.value })
            }
          >
            <option value="">Select Role</option>
            <option value="sitemaster">Sitemaster</option>
            <option value="reviewer">Reviewer</option>
          </select>
        </div>

        <button onClick={handleLogin} disabled={loading} style={button}>
          {loading ? "Logging..." : "Login"}
        </button>
      </div>
    </div>
  );
}



const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #f5e2db, #a67c6b)",
  padding: "15px",
  boxSizing: "border-box",
};

const card = {
  background: "#ffffff",
  padding: "35px 30px",
  borderRadius: "16px",
  width: "100%",
  maxWidth: "350px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  boxSizing: "border-box",
};

const inputBox = {
  display: "flex",
  alignItems: "center",
  background: "#f7f7f7",
  padding: "12px 14px",
  borderRadius: "25px",
  marginBottom: "15px",
  border: "1px solid #eee",
  width: "100%",
  boxSizing: "border-box",
};

const icon = {
  marginRight: "10px",
  color: "#6c4636",
};

const input = {
  border: "none",
  outline: "none",
  background: "transparent",
  width: "100%",
  fontSize: "14px",
  minWidth: "0",
};

const selectStyle = {
  border: "none",
  outline: "none",
  background: "transparent",
  width: "100%",
  fontSize: "14px",
  cursor: "pointer",
  minWidth: "0",
};

const button = {
  width: "100%",
  padding: "12px",
  borderRadius: "25px",
  border: "none",
  background: "#D4c2BB",
  color: "#3e2a22",
  fontWeight: "bold",
  cursor: "pointer",
};

export default Login;